/* prettier-ignore */
import { UnprocessableEntityViolationParameters } from '../types/unprocessable-entity-violation-parameters';
import { UnprocessableEntityViolation } from '../types/unprocessable-entity-violation';
import { HttpErrorResponse } from '@angular/common/http';

export class UnprocessableEntityHttpErrorResponse<
  Code,
  Parameters extends UnprocessableEntityViolationParameters,
> {
  private constructor(
    private readonly data: {
      title: string;
      detail: string;
      violations: Array<UnprocessableEntityViolation<Code, Parameters>>;
    },
  ) {}

  public get violations(): Array<
    UnprocessableEntityViolation<Code, Parameters>
  > {
    return this.data.violations;
  }

  public static fromResponse<Code, Parameters extends number | string | symbol>(
    response: HttpErrorResponse,
  ): UnprocessableEntityHttpErrorResponse<Code, Parameters> {
    return new UnprocessableEntityHttpErrorResponse<Code, Parameters>({
      detail: response.error.detail,
      title: response.error.title,
      violations: response.error.violations.map(
        (violations: Record<string, object>) => {
          const { type, ...rest } = violations;

          return { ...rest, code: type };
        },
      ),
    });
  }
}
